import React, { useState, ChangeEvent, FC, useEffect } from 'react';

interface EngineTemperatureCANProps {
  alarm: any;
  onChange: (newMetrics: any) => void;
}

const EngineTemperatureCAN: FC<EngineTemperatureCANProps> = ({ alarm, onChange }) => {
  const [temperatureThreshold, setTemperatureThreshold] = useState<number>(0);

  useEffect(() => {
    if (alarm !== "") {
      setTemperatureThreshold(alarm.temperature_threshold);
    } else {
      setTemperatureThreshold(0);
    }
  }, [alarm]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(event.target.value);
    setTemperatureThreshold(value);
    onChange({ type: "EngineTemperatureCAN", temperature_threshold: value });
  };

  return (
    <div className="input-group col-md-4 col-sm-4">
      <input
        className="form-control input-sm"
        name="engine_temperature"
        value={temperatureThreshold}
        placeholder="Temperature Threshold (e.g. 95)"
        type="number"
        step="0.1"
        size={10}
        maxLength={20}
        onChange={handleInputChange}
      />
      <span style={{ paddingLeft: 10 }} className="input-group-addon">°C</span>
    </div>
  );
};

export default EngineTemperatureCAN;
